import classNames from 'classnames';
import React from 'react';
const PageHeading = ({
  primaryText,
  secondaryText,
  primaryTextClassName,
  secondaryTextClassName
}) => {
  const primaryTextClassNames = classNames('font-semibold', 'mb-12', 'text-4xl', 'text-center', 'text-slate-800', `${secondaryText ? 'mt-1' : 'mt-6'}`, `${primaryTextClassName ?? ''}`);
  const secondaryTextClassNames = classNames('font-semibold', 'my-4', 'text-center', 'text-slate-500', 'text-sm', 'uppercase', `${secondaryTextClassName ?? ''}`);
  return /*#__PURE__*/React.createElement(React.Fragment, null, secondaryText && /*#__PURE__*/React.createElement("h3", {
    className: secondaryTextClassNames
  }, secondaryText), /*#__PURE__*/React.createElement("h2", {
    className: primaryTextClassNames
  }, primaryText));
};
export default PageHeading;